<template>
  <Modal ref="modal" title="Doações">
    <form class="form-container" @submit.prevent="handleSubmit">
      <InputMonth legend="Insira a data" :modelValue="mes" @update:modelValue="$event => this.mes = $event"
        :disabled="exportLoading" />

      <Button class="form-button" text="Fazer download" color="primary" :disabled="exportLoading">
        <DownloadOutline :size="18" />
      </Button>
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import InputMonth from 'core/InputMonth'
import Button from 'core/Button'
import DownloadOutline from 'icons/DownloadOutline'
import _export from '../../../../services/export'

export default {
  name: 'DoacoesModal',
  components: {
    Modal,
    InputMonth,
    Button,

    DownloadOutline,
  },
  data() {
    return {
      mes: '',
      exportLoading: false,
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    async handleSubmit() {
      if (this.validateMonth()) {
        await this.submitExport()
      }
    },
    async submitExport() {
      this.exportLoading = true

      await this.$http.get(`${process.env.VUE_APP_URL_API}/cfc/relatorio/doacoes-por-autoescola/${this.mes}`)
        .then((res) => {
          _export.downloadPDF(res.body.dados, 'doacoes')
        })
        .catch((err) => {
          this.$toasted.show(`Erro ao tentar gerar relatório: ${err.body.mensagem}`, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    validateMonth() {
      if (!this.mes) {
        this.$toasted.show(`Preencha todos os campos`, {
          position: 'top-right',
        })

        return false
      }

      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.form-container {
  width: 30vw;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .form-button {
    justify-content: center;
  }
}
</style>
